import { onMounted, ref } from 'vue'

export function useDeviceSize() {
    const isTabletPlus = ref(false)

    onMounted(() => {
        // keep in sync with src/assets/styles/custom-media.css
        isTabletPlus.value = window.innerWidth > 480 && window.innerHeight > 480
    })

    return {
        isTabletPlus,
    }
}
